import { render, staticRenderFns } from "./Table-comp.vue?vue&type=template&id=375090e8&scoped=true&"
import script from "./Table-comp.vue?vue&type=script&lang=js&"
export * from "./Table-comp.vue?vue&type=script&lang=js&"
import style0 from "./Table-comp.vue?vue&type=style&index=0&id=375090e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375090e8",
  null
  
)

export default component.exports